import { useEffect, useState } from 'react';

/** Ist das Gerät online? (navigator.onLine, aktualisiert bei «online»/«offline») */
export const useOnline = () => {
  const [online, setOnline] = useState(() => navigator.onLine !== false);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  return online;
};
